import React from "react";
import {format} from "date-fns";
import {utcToZonedTime} from "date-fns-tz";
import {TimeZones} from "../../../shared/enums/timeZones";
import parse from "html-react-parser";
import {useTranslation} from "react-i18next";
import {recurrenceDaily, recurrenceMonthly} from "../../../shared/constants";
import {EventRecurrenceDetails} from "../../../stores/domainStore/pages/models/eventRecurrenceDetails";

export interface IEventSeriesTimeAndDateFormatProps {
  eventRecurrenceDetails: EventRecurrenceDetails;
  timeAndDate: Date;
  isEnhanced: boolean;
  endTime?: Date;
  recurrenceEndDate?: Date | null;
  timeZone?: string;
}

const EventSeriesTimeAndDateFormat: React.FC<
  IEventSeriesTimeAndDateFormatProps
> = ({
  eventRecurrenceDetails,
  timeAndDate,
  isEnhanced,
  endTime,
  recurrenceEndDate,
  timeZone = TimeZones.Auckland
}) => {
  const {t} = useTranslation(["translation", "event"]);
  const days = eventRecurrenceDetails.weekdays.getDisplayLabel();
  const week = eventRecurrenceDetails.monthWeeks.getDisplayLabel();
  const getFormattedHour = (date: Date | number) =>
    format(date, "h:mmaaa").replace(":00", "");
  const recurrenceSummaryMessage = (): string => {
    const currentDate = new Date();
    const isPastEvent = recurrenceEndDate! < currentDate;

    const messagePrefix = isEnhanced ? "enhanced" : "engage";
    const messageSuffix = isPastEvent ? "ViewPast" : "ViewCurrent";
    const messageMiddle =
      eventRecurrenceDetails.frequency === recurrenceMonthly
        ? "RecurrenceSummaryMonthly"
        : "RecurrenceSummaryDailyWeekly";

    return `event:messages.${messagePrefix}${messageMiddle}${messageSuffix}`;
  };

  return (
    <span>
      {parse(
        t(recurrenceSummaryMessage(), {
          days:
            eventRecurrenceDetails.frequency === recurrenceDaily
              ? days
              : format(utcToZonedTime(timeAndDate!, timeZone), "iiii"),
          startTime: getFormattedHour(utcToZonedTime(timeAndDate!, timeZone)),
          endTime: getFormattedHour(utcToZonedTime(endTime!, timeZone)),
          startDate: format(
            utcToZonedTime(timeAndDate!, timeZone),
            "dd/MM/yyyy"
          ),
          endDate: format(
            utcToZonedTime(recurrenceEndDate!, timeZone),
            "dd/MM/yyyy"
          ),
          weeks: week
        })
      )}
    </span>
  );
};

export default EventSeriesTimeAndDateFormat;
